import React, { CSSProperties } from 'react';
import classNames from 'classnames';

import styles from './Indicator.module.css';

type IndicatorProps = React.ComponentProps<'div'>;
const Indicator = (props: IndicatorProps) => {
  const { className, color, ...otherProps } = props;
  return (
    <div
      {...otherProps}
      style={{ '--budgetItemIndicatorColor': color } as CSSProperties}
      className={classNames(styles.Indicator, className)}
    />
  );
};
export default Indicator;
